"use client";

import { useEffect, useState, type CSSProperties } from "react";
import { createPortal } from "react-dom";
import { useTheme } from "next-themes@0.4.6";
import { Toaster as Sonner, ToasterProps } from "sonner";
import { useUIStore } from "@stores/useUIStore";

export const DASHBOARD_TOAST_Z_INDEX = 2_147_483_647;

const Toaster = ({
  className,
  position = "top-right",
  style,
  ...props
}: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const animationReduced = useUIStore((state) => state.animationReduced);
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalTarget(document.body);
  }, []);

  const toaster = (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className={[
        "toaster group bbb-toaster",
        animationReduced ? "bbb-motion-muted" : "",
        className ?? "",
      ]
        .filter(Boolean)
        .join(" ")}
      style={{
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
        zIndex: DASHBOARD_TOAST_Z_INDEX,
        ...style,
      } as CSSProperties}
      position={position}
      {...props}
    />
  );

  return portalTarget ? createPortal(toaster, portalTarget) : toaster;
};

export { Toaster };
